import { publish } from '../../pubsub';
import useContainerProps from '../helpers/useContainerProps';

/**
 * Fire when user change home type filter in any AirBnB component
 * @param {Object} container
 * @param {String} homeType
 *
 */
export default (container, homeType) => {
  const { eventType } = useContainerProps(container);
  publish(`em.listing.${eventType}.homeType`, {
    homeType
  });
};
